import type { $Fetch } from "nitropack";

const api = (client: $Fetch) => (resource: string) => ({
    list: (params, config) => client(`/${resource}`, { ...config, params }),
    get: (id: string | number, config?: any) => client(`/${resource}/${id}`, { ...config }),
    create: (data, config) => client(`/${resource}`, { method: 'POST', body: data, ...config }),
    update: (id: string | number, data, config = {}) => client(`/${resource}/${id}`, { method: 'PATCH', body: data, ...config }),
    remove: (id: string | number, config) => client(`/${resource}/${id}`, { method: 'DELETE', ...config }),
});

export default api;